export { HeightAnimator, HeightAnimatorProps } from '@tableau/tableau-ui';
